import React, { forwardRef } from 'react'
import { isVideo, showToast } from '../../../utils';
import CustomVideo from '../../../global/ui/CustomVideo';
interface ISelectedFolder {
    setView: (type: any) => void;
    handleUpload: (value: any) => void;
    activeFolder: any;
    handleRemovePhoto: (data: any, idx: any) => any;
    makeThumbnail?: (index: any) => void;
}

const SelectedFolder = forwardRef(({ setView, activeFolder, handleRemovePhoto, handleUpload, makeThumbnail }: ISelectedFolder, ref: any) => {
    return (
        <div className="cl-step">
            <h3 className="cl-step__heading">Add Photos</h3>
            <div className="cl-breadcrumb">
                <button onClick={() => setView('galleries')}>Galleries</button>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
                <span>{activeFolder?.name}</span>
            </div>

            <div className="cl-photo-grid">
                {activeFolder?.photos?.map((src: any, i: number) => (
                    <div
                        key={i}
                        className={`cl-photo-item`}
                        onClick={() => {
                            if (isVideo(src)) {
                                showToast('Videos cannot be set as thumbnails. Please select an image.', 'error');
                                return
                            }
                            makeThumbnail?.(i)
                        }}
                        style={{ border: src?.thumbnail ? "3px solid #ffd400" : '' }}
                    >
                        {isVideo(src) ? (
                            <CustomVideo
                                controls={false}
                                src={src?.image}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        ) : (
                            <img
                                src={src?.image}
                                alt={`photo-${i}`}
                            />
                        )}
                        {/* Thumbnail hover overlay */}
                        <div className="cl-photo-item__thumbnail-overlay">
                            <span>Use as thumbnail</span>
                        </div>

                        <button
                            className="cl-photo-item__remove"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleRemovePhoto(src, i);
                            }}
                        >
                            <svg
                                width="10"
                                height="10"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="3"
                                strokeLinecap="round"
                            >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>
                ))}

                {/* Upload tile */}
                <button
                    className="cl-photo-upload-tile"
                    onClick={() => ref.current?.click()}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6b5ce7" strokeWidth="2">
                        <polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" />
                        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                    </svg>
                    <span>Upload</span>
                </button>
            </div>
            <input
                ref={ref}
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={(e) => handleUpload(e.target.files)}
            />
        </div>
    )
})

export default SelectedFolder